import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useField } from 'formik'

import { Checkbox, CHECKBOX_SIZE } from '../../../../../../../Checkbox'
import { CustomSelect } from '../../../../../../../CustomSelect'
import { FormFieldSelect } from '../../../../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldErrorProps,
  getFormikCheckboxFieldValueProps,
} from '../../../../../../../Formik'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX,
  REGISTERED_USERS_OPTIONS,
} from '../../../RecipientsField.constants'
import { getUserFieldLabel } from '../CustomizeRecipientAudienceFormFields.utils'

import * as styles from '../../CustomizeRecipientAudienceModal.module.css'

function RegisteredUsersFields() {
  const { t } = useTranslation()

  const [field] = useField(
    NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX
  )

  const buttonClassName = classNames({ [styles.disabledSelect]: !field.value })

  return (
    <>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getErrorProps={getFormikCheckboxFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('Newsboard.RecipientsRegisteredUsersLabelKey')}
        labelClassName={styles.checkboxLabel}
        name={
          NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX
        }
        size={CHECKBOX_SIZE.small}
      />
      <FormikField
        showLabel
        Component={FormFieldSelect}
        Field={Fragment}
        Select={CustomSelect}
        buttonClassName={buttonClassName}
        buttonType='select'
        disabled={!field.value}
        getLabel={getUserFieldLabel}
        name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS}
        options={REGISTERED_USERS_OPTIONS}
        placeholder={t('Newsboard.RecipientsRegisteredUsersPlaceholderKey')}
      />
    </>
  )
}

export default RegisteredUsersFields
